import { render, staticRenderFns } from "./VanDropdownCheckbox.vue?vue&type=template&id=d2f6aa54&scoped=true&"
import script from "./VanDropdownCheckbox.vue?vue&type=script&lang=js&"
export * from "./VanDropdownCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VanDropdownCheckbox.vue?vue&type=style&index=0&id=d2f6aa54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f6aa54",
  null
  
)

export default component.exports